<template>
  <div class="page-header-index-wide">
    <a-button type="primary"  @click="refreshData" style="margin-bottom: 3px;">{{language['common.refresh']}}</a-button>
    <a-row :gutter="24">
      <a-col :sm="24" :md="12" :xl="6" :style="{ marginBottom: '24px' }">
          <a-card :title="language['emp.home.totalUser']+':'" :bordered="false" :body-style="{ padding: '20px 24px 8px' }" >
            <a slot="extra" @click="toUserList"><span style="font-weight: 800;font-size: large;color: white;">{{ userCountInfo.totalNum }}&nbsp;{{language['emp.home.people']}} </span> </a>
            <p><span >{{language['emp.home.newUserToday']}}:&nbsp;&nbsp;</span><span style="font-weight: 600;color: red;">+{{userCountInfo.todayNewNum}}</span></p>
            <p><span >{{ language['emp.home.todayVisit'] }}:&nbsp;&nbsp;{{userCountInfo.todayVisitNum}} </span><span style="font-weight: 600;color: red;">&nbsp;&nbsp;({{language['emp.home.compareYest']}}</span><span style="font-weight: 600;color: red;" v-show="userCountInfo.compareYesterdayNum>0">+</span><span style="font-weight: 600;color: red;">{{userCountInfo.compareYesterdayNum}})</span></p>
          </a-card>
      </a-col>
      <a-col :sm="24" :md="12" :xl="6" :style="{ marginBottom: '24px' }">

        <a-card :title="language['emp.home.allContentNumber']+':'" :bordered="false" :body-style="{ padding: '20px 24px 8px' }" >
          <a slot="extra"  @click="toContent"><span style="font-weight: 800;font-size: large;color: white;">{{ contentAllNumber }}</span> </a>
          <p><span >{{language['emp.home.bulletinBoard']}}:&nbsp;&nbsp;{{bulletinBoardContentNumber}}</span><span style="font-weight: 600;color: red;" v-show="bulletinBoardTodayContentNumber>0"> &nbsp;&nbsp;( {{language['emp.home.today']}}:+{{ bulletinBoardTodayContentNumber }} )</span></p>
          <p><span >{{language['emp.home.personnelAnnouncement']}}:&nbsp;&nbsp;{{personnelAnnouncementContentNumber}}</span><span style="font-weight: 600;color: red;" v-show="personnelAnnouncementTodayContentNumber>0"> &nbsp;&nbsp;( {{language['emp.home.today']}}:+{{ personnelAnnouncementTodayContentNumber }} )</span></p>
          <p><span >{{language['emp.home.managementMeasuresZone']}}:&nbsp;&nbsp;{{managementMeasuresZoneContentNumber}}</span><span style="font-weight: 600;color: red;" v-show="managementMeasuresZoneTodayContentNumber>0"> &nbsp;&nbsp;( {{language['emp.home.today']}}:+{{ managementMeasuresZoneTodayContentNumber }} )</span></p>
          <p><span >{{language['emp.home.educationTrainingZone']}}:&nbsp;&nbsp;{{educationTrainingZoneContentNumber}}</span><span style="font-weight: 600;color: red;" v-show="educationTrainingZoneTodayContentNumber>0"> &nbsp;&nbsp;( {{language['emp.home.today']}}:+{{ educationTrainingZoneTodayContentNumber }} )</span></p>
          <!--<p
            v-for="(item, i) in appStatInfo.appTypeStatList"
            :key="i"
            :value="item.appTypeCode"
          >
            <span>{{ item.appTypeName }}:&nbsp;&nbsp;{{ item.applicationNum }}</span><span style="font-weight: 600;color: red;" v-show="item.todayApplicationNum>0"> &nbsp;&nbsp;( {{language['emp.home.today']}}:+{{ item.todayApplicationNum }} )</span>
          </p>-->
        </a-card>
      </a-col>
      <a-col :sm="24" :md="12" :xl="6" :style="{ marginBottom: '24px' }">

        <a-card :title="language['emp.home.totalApps']+':'" :bordered="false" :body-style="{ padding: '20px 24px 8px', overflowY: 'auto', height: '290px' }" >
          <a slot="extra"  @click="toApplicationList"><span style="font-weight: 800;font-size: large;color: white;">{{ appStatInfo.totalNum }}</span> </a>
          <p
            v-for="(item, i) in appStatInfo.appTypeStatList"
            :key="i"
            :value="item.appTypeCode"
          >
            <span>{{ item.appTypeName }}:&nbsp;&nbsp;{{ item.applicationNum }}</span><span style="font-weight: 600;color: red;" v-show="item.todayApplicationNum>0"> &nbsp;&nbsp;( {{language['emp.home.today']}}:+{{ item.todayApplicationNum }} )</span>
          </p>
        </a-card>
      </a-col>
      <a-col :sm="24" :md="12" :xl="6" :style="{ marginBottom: '24px' }">
        <a-card :title="language['common.sum']" :bordered="false" :body-style="{ padding: '20px 24px 8px' }" >
          <!--<a slot="extra" @click="toUserList"><span style="font-weight: 800;font-size: large">{{ userCountInfo.totalNum }}&nbsp;{{language['emp.home.people']}} </span> </a>-->
          <p><span >{{language['emp.home.contentTotalClickSize']}}:&nbsp;&nbsp;</span><span style="font-weight: 600;">{{contentTotalClickSize}}</span></p>
          <!--<p><span >今日内容点击:&nbsp;&nbsp; </span><span style="font-weight: 600;color: red;">&nbsp;&nbsp;({{language['emp.home.compareYest']}}</span><span style="font-weight: 600;color: red;" v-show="userCountInfo.compareYesterdayNum>0">+</span><span style="font-weight: 600;color: red;">{{userCountInfo.compareYesterdayNum}})</span></p>-->
          <p><span >{{language['emp.home.contentTodayClickSize']}}:&nbsp;&nbsp;</span><span style="font-weight: 600;">{{contentTodayClickSize}}</span></p>
          <br/>
          <p><span >{{language['emp.home.subscriptionsAppSize']}}:&nbsp;&nbsp;</span><span style="font-weight: 600;">{{subscriptionsAppSize}}</span></p>
          <p><span >{{language['emp.home.subscriptionsAppTodaySize']}}:&nbsp;&nbsp; </span><span style="font-weight: 600;">{{subscriptionsAppTodaySize}}</span></p>
        </a-card>
      </a-col>
    </a-row>

    </div>

</template>

<script>
import { getAction,putAction } from '@/api/manage'
import ChartCard from '@/components/ChartCard'
export default {
  name: "EmpHome",
  components: {
    ChartCard,
  },
  data(){
    return{
      userCountInfo: {
        totalNum: 0,
        todayNewNum: 0,
        todayVisitNum: 0,
        compareYesterdayNum: 0
      },
      appStatInfo: {
        totalNum: 0,
        appTypeStatList: []
      },
      subscriptionsAppSize:0,
      subscriptionsAppTodaySize:0,
      contentTotalClickSize:0,
      contentTodayClickSize:0,

      contentAllNumber:0,
      bulletinBoardContentNumber:0,
      bulletinBoardTodayContentNumber:0,
      personnelAnnouncementContentNumber:0,
      personnelAnnouncementTodayContentNumber:0,
      managementMeasuresZoneContentNumber:0,
      managementMeasuresZoneTodayContentNumber:0,
      educationTrainingZoneContentNumber:0,
      educationTrainingZoneTodayContentNumber:0,
    }
  },
  computed:{
    language() {
      return this.$store.getters.language
    },
  },
  created() {
    this.getUserStat();
    this.getAppStat();
    this.initSubscriptionsApp();
    this.initContentClickSize();
    this.initConentNumber();
  },
  methods:{
    refreshData(){
      this.getUserStat();
      this.getAppStat();
      this.initSubscriptionsApp();
      this.initContentClickSize();
      this.initConentNumber();
    },
    initConentNumber(){
      this.contentAllNumber = 0;
      getAction("/hhemp/colContent/getContentNumberByColType",{entranceCode:this.$store.getters.application.applicationCode,colType:"bulletinBoard"}).then((res)=>{
        if(res.success){
          this.bulletinBoardContentNumber = res.result.conentNumber
          this.bulletinBoardTodayContentNumber= res.result.todayContentNumber
          this.contentAllNumber = this.contentAllNumber+res.result.conentNumber;
        }
      })
      getAction("/hhemp/colContent/getContentNumberByColType",{entranceCode:this.$store.getters.application.applicationCode,colType:"personnelAnnouncement"}).then((res)=>{
        if(res.success){
          this.personnelAnnouncementContentNumber = res.result.conentNumber
          this.personnelAnnouncementTodayContentNumber= res.result.todayContentNumber
          this.contentAllNumber = this.contentAllNumber+res.result.conentNumber;
        }
      })
      getAction("/hhemp/colContent/getContentNumberByColType",{entranceCode:this.$store.getters.application.applicationCode,colType:"managementMeasuresZone"}).then((res)=>{
        if(res.success){
          this.managementMeasuresZoneContentNumber = res.result.conentNumber
          this.managementMeasuresZoneTodayContentNumber= res.result.todayContentNumber
          this.contentAllNumber = this.contentAllNumber+res.result.conentNumber;
        }
      })
      getAction("/hhemp/colContent/getContentNumberByColType",{entranceCode:this.$store.getters.application.applicationCode,colType:"educationTrainingZone"}).then((res)=>{
        if(res.success){
          this.educationTrainingZoneContentNumber = res.result.conentNumber
          this.educationTrainingZoneTodayContentNumber= res.result.todayContentNumber
          this.contentAllNumber = this.contentAllNumber+res.result.conentNumber;
        }
      })
    },
    initSubscriptionsApp(){
      getAction("/hhemp/empsubscriptionsapplication/list",{entranceCode:this.$store.getters.application.applicationCode}).then((res)=>{
        if(res.success){
          this.subscriptionsAppSize = res.result;
        }
      })
      getAction("/hhemp/empsubscriptionsapplication/todaylist",{entranceCode:this.$store.getters.application.applicationCode}).then((res)=>{
        if(res.success){
          this.subscriptionsAppTodaySize = res.result;
        }
      })
    },
    initContentClickSize(){
      getAction("/hhemp/colContent/getClickContentNumber",{entranceCode:this.$store.getters.applicationCode,colType:"bulletinBoard,personnelAnnouncement,managementMeasuresZone,educationTrainingZone"}).then((res)=>{
        if(res.success){
          let map = res.result;
          this.contentTotalClickSize = map.totalClick;
          this.contentTodayClickSize = map.todayClick;
        }
      })
    },
    getUserStat(){
      getAction("/hhemp/home/getUserStat",{entranceCode:this.$store.getters.application.applicationCode}).then((res)=>{
        if(res.success){
          this.userCountInfo = res.result;
        }
      })
    },
    getAppStat(){
      getAction("/hhemp/home/getAppStat",{entranceCode:this.$store.getters.application.applicationCode}).then((res)=>{
        if(res.success){
          this.appStatInfo = res.result;
        }
      })
    },

    toUserList(){
      getAction("/sys/permission/getSystemMenuByComponent",{applicationCode:this.$store.getters.application.applicationCode,component:'hhemp/basedata/UserList'}).then((res)=>{
        if(res.success){
          let permission = res.result;
          this.$router.push({
            path: permission.url
          });
        }
      })
    },
    toContent(){
      this.$router.push({
        path: "/hhemp/CmsContentTblPublish"
      });
    },
    toApplicationList(){
      getAction("/sys/permission/getSystemMenuByComponent",{applicationCode:this.$store.getters.application.applicationCode,component:'hhemp/basedata/SysBmApplicationList'}).then((res)=>{
        if(res.success){
          let permission = res.result;
          this.$router.push({
            path: permission.url
          });
        }
      })
    },
  }
}
</script>

<style lang="less" scoped>
.circle-cust{
  position: relative;
  top: 28px;
  left: -100%;
}
.extra-wrapper {
  line-height: 55px;
  padding-right: 24px;

  .extra-item {
    display: inline-block;
    margin-right: 24px;

    a {
      margin-left: 24px;
    }
  }
}

/* 首页访问量统计 */
.head-info {
  position: relative;
  text-align: left;
  padding: 0 32px 0 0;
  min-width: 125px;

  &.center {
    text-align: center;
    padding: 0 32px;
  }

  span {
    color: rgba(0, 0, 0, .45);
    display: inline-block;
    font-size: .95rem;
    line-height: 42px;
    margin-bottom: 4px;
  }
  p {
    line-height: 42px;
    margin: 0;
    a {
      font-weight: 600;
      font-size: 1rem;
    }
  }
}


</style>

<style scoped>
.ant-card {
  height: 350px;
}
/deep/ .ant-card-head {
  background-color: #3260c9 !important;
  color: white !important;
}
</style>